import "../../components/css/News.css";
import PageTitle from "../../components/pagetitle/PageTitle";
import gambar from "../../Images/News/GuruMuda.WebP";

function News2() {
  return (
    <>
      <PageTitle motherMenu="Media Coverage" menuback="Previous Page" backbtn="/PageNewsList" activeMenu="" />
      <div className="mt-5">
        <section className="feature section pt-0">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 ml-auto justify-content-center">
                {/* <!-- About Mockup --> */}

                {/* <div className="image-content" data-aos="fade-right"> */}
                <img className="img-fluid" src={gambar} alt="" />
                {/* </div> */}
              </div>
              <div className="col-lg-6 mr-auto align-self-center">
                <div className="feature-content">
                  {/* <!-- About Title --> */}

                  <h2>
                    <b>
                      Young Teachers from Corners of Central Kalimantan Achieve
                      Achievements at YISF Bali
                    </b>
                  </h2>

                  {/* <!-- About Description --> */}

                  <p className="desc">
                    <b></b>
                    SUGENG Santoso, a young teacher at SMPS 11 Best Agro Pulang
                    Pisau (Pulpis) sparked a digital application to open a
                    discussion space for teachers. Best Teach, a social media
                    application for teachers that can be a space for discussion
                    and sharing of teaching practices.He carried this innovation
                    at the Youth International Science Fair (YISF) competition
                    held in Bali. This event was initiated by PGRI Mahadewa
                    Indonesia University, Indonesian Young Scientist
                    Association, Faculty of Engineering, Diponegoro University,
                    and BUCA IMSEF Turkey.
                    <br />
                    <br />
                    In this competition, Sugeng was faced with 400 teams from 30
                    countries. Among them are Malaysia, Thailand, Turkey, India,
                    Pakistan, Brazil, Romania, and America. Sunday (12/3),
                    Sugeng returned to his place of service located in the
                    interior of Pulpis, Central Kalimantan with an award.
                    <br />
                    <br />
                    He won a silver medal in this international event, by
                    carrying out innovation in the social science category." I
                    am grateful that as one of the teachers in Central
                    Kalimantan, I was able to return home with an award in the
                    form of a silver medal in the innovation competition in the
                    social science category. The competition that I participated
                    in this international event was in the form of the "Best
                    Teach" platform, a social media for teachers that can be
                    used as a discussion space and share teaching practices,"
                    Sugeng said when contacted by Kalteng by telephone,
                    Wednesday (15/3).
                    <br />
                    <br />
                    Sugeng received various praises in this competition. Both
                    from the jury, WR 1 PGRI Mahadewa Indonesia University,
                    finalist supervisors, even the competition finalists who
                    became rivals. The platform he initiated will be a forum for
                    teachers to share and develop knowledge."Even though I only
                    got a silver medal, I am still grateful, because I have
                    proven that I am able to compete at the international level.
                    My hope is that education in this country will move
                    forward," said the 22-year-old man.
                    <br />
                    <br />
                    The emergence of the idea to create this application was
                    motivated by the geographical conditions and location of the
                    school where he served in the interior, which had to be
                    reached for five hours by land or two hours by river from
                    Pulang Pisau City."The purpose of making this work is to
                    provide space for teachers at Best Agro to be able to share
                    various information, share the latest knowledge, as well as
                    media and learning strategies," he said.Before initiating
                    this idea, the man who was born in Blitar on May 18, 1999,
                    said that previously he had conducted an analysis related to
                    problems in SMPS. Although it has been reached by
                    electricity and internet networks, the distance to travel
                    out of this area is quite far, thus limiting teachers from
                    leaving the area.
                    <br />
                    <br />
                    "We looked for a solution for that, after analyzing and
                    looking for references, then this idea came up. Next, I made
                    the Best Teach design," said the man who claimed to have a
                    hobby of writing.Sugeng thought of creating this
                    application, because the discussion space through the
                    current platform is very limited."Through this idea, later
                    the teachers where I teach can be one frequency," said an
                    alumnus of Ganesha University who teaches Indonesian
                    subjects.In this competition, Sugeng took an English teacher
                    from SMPS Hamparan 2 Kotawaringim Timur named Saidah to join
                    his team. Because the presentation of the competition must
                    use English.
                    <br />
                    <br />
                    "I came up with the idea, but Saidah's mother also helped
                    with the presentation," he said. Even though he is a
                    Indonesian teacher, Sugeng has basic designing that he
                    learned by himself. He really hopes that his Best Tech
                    design idea can be realized into an application."To realize
                    that, it does need funding, to be developed into a social
                    media application, it must be developed by experts who have
                    basic IT," he explained.Sugeng, a young nomad from Java
                    Island, chose to become a teacher in the interior of Central
                    Kalimantan. It's only been about six months.
                    <br />
                    <br />
                    "I've only been a teacher for a year. Previously taught in
                    Probolinggo, East Java. I have only been teaching in Central
                    Kalimantan for six months. I want to explore myself. And I
                    believe many students have the right to be taught by me,"
                    said the man who since childhood has aspired to become a
                    teacher.Sugeng has won several awards. Among others, the
                    first place in national creative photos and the first place
                    in national learning design. In addition, he has also guided
                    students in three schools to win national champions. "I like
                    teaching, from childhood I have dreams of becoming a
                    teacher, because I want to contribute to educating the
                    nation's children," he concluded.
                  </p>
                  <p>
                    Source :{" "}
                    <a
                      href="https://berau.prokal.co/read/news/73685-guru-muda-dari-pelosok-kalteng-raih-prestasi-di-yisf-bali.html"
                      target="_blank"
                      rel="noreferrer"
                    >
                      click here
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default News2;
